import { TreatmentDesignRevisionLiability } from '../treatment-design-revision-judgement';

/** A revision reason as listed on the 返修判断管理 settings page. */
export interface DesignRevisionReason {
    readonly id: number;
    readonly content: string;
    /** Null means the reason is offered for every treatment type. */
    readonly treatmentTypeOriginalId?: number | null;
    readonly revisionLiability: TreatmentDesignRevisionLiability;
    readonly isActive: boolean;
    readonly displayOrder: number;
    /** Judgements already pointing at this reason; non-zero means it can only be deactivated. */
    readonly usageCount: number;
    readonly modifiedDate: string;
    readonly modifiedBy?: string | null;
}
